/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable guard-for-in */
/* eslint-disable no-console */

import SelectorEngine from '../../../utils/dom/selector-engine';
import { Events } from '../../../utils/dom/html-events';
import { ClassNames } from '../../../utils/dom/css-classes';
import Request, { ApiMode } from '../../../utils/request';
import FormGenerator, { FormTypes } from '../../../components/FormGenerator';
import EventHandler from '../../../utils/dom/event-handler';
import Modal from '.../../../components/Modal';
import { startLoadingAnimation, stopLoadingAnimation } from '../../../utils/dom/loading';
import Manipulator from '../../../utils/dom/manipulator';
import AddressSearch from '../../../components/AddressSearch';

const SELECTOR_WRAPPER = '.p-officials-licence-renewal';
const SELECTOR_MODAL = '.js-officials-licence-renewal-modal';

const SELECTOR_SPLASH = '.p-officials-licence-renewal-splash';
const SELECTOR_SPLASH_NEXT = '.p-officials-licence-renewal-splash-next';

const SELECTOR_STEP = '.p-officials-licence-renewal-step';
const SELECTOR_QUESTION = '.p-officials-licence-renewal-questions';

const SELECTOR_EXIT_BUTTON = '.js-exit-officials-licence-renewal';
const SELECTOR_EXIT_CONFIRM_MODAL = '.js-exit-officials-licence-renewal-confirm';
const SELECTOR_EXIT_CONFIRM_YES = '.js-exit-officials-licence-renewal-confirm-yes';
const SELECTOR_EXIT_CONFIRM_NO = '.js-exit-officials-licence-renewal-confirm-no';
const SELECTOR_ERRROR_CONTAINER = '.p-officials-licence-renewal-error-container';
const ADDRESS_SEARCH_RESULT = '.lta-address-search--result';
const RENEWAL_EDIT_ADDRESS = '.lta-licence-renewal-edit';
const ADDRESS_SEARCH_CARD = 'lta-address-card';
const BILLING_ADDRESS_WRAPPER = '.lta-address-search';
const ADDRESS_SEARCH_FIND = '.lta-address-search--find';
const LOCATION_CARD_SEARCH = '.lta-location-card--content';
const CONTENT_ADDRESS_SEARCH = '.lta-address-search--edit';
const ADDRESS_SEARCH_FIND_SUGGEST = '.lta-address-search--find-suggest';
const CHECKOUT_WRAPPER = '.checkout-wrapper';
const DISMISS_ERROR_WRAPPER = '.js-dismiss-error';
const ERROR_TEXT = '.error-text';
const PAID_VALUE_WRAPPER = '.paid-licence-wrapper';
const FREE_VALUE_WRAPPER = '.free-licence-wrapper';
const VENUE_ADDRESS_SEARCH = '.lta-venue-address-search';
export const EVENT_EDIT_ADDRESS_MANUALLY = 'EVENT_EDIT_ADDRESS_SEARCH';
export const EVENT_EDIT_ADDRESS_SEARCH = 'EVENT_EDIT_ADDRESS_SEARCH';
const SELECTOR_HOUSE_INPUT = 'houseNumber';

const IS_LOCAL = false;
const FORM_GENERATOR_PREFIX = 'lta-form-generator';
const KEY_OBJECT = 'fieldName';
const CLICK_EVENT = 'click';
const VALUE_OBJECT = 'value';
const HIDDEN_CLASS = 'u-hidden';

class OfficialsLicenceRenewal {
	constructor() {
		this.state = {
			address: undefined,
			billingAddress: {}
		};
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this._changeCallbacks = [];
		this.disbaleFocus = false;
		this._inView = undefined;
		this.classPrefix = FORM_GENERATOR_PREFIX;
		this.isLicenceFree = Manipulator.getDataAttribute(this._wrapper, 'purchase-free');
		this.contactId = Manipulator.getDataAttribute(this._wrapper, 'contact-id');
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		if (_stepsData?.length > 0) {
			this._stepsData = _stepsData;
		}
	}

	init() {
		this.modalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);
		this.modal = new Modal(this.modalElement, { backdrop: 'static' });
		this.modal.show();

		this.splash = SelectorEngine.findOne(SELECTOR_SPLASH, this._wrapper);
		this.splashNext = SelectorEngine.findOne(SELECTOR_SPLASH_NEXT, this.splash);
		this.nextButton = SelectorEngine.findOne(`.${this.classPrefix}__form-next-button`, this._wrapper);

		this.step = SelectorEngine.findOne(SELECTOR_STEP, this._wrapper);
		this.questions = SelectorEngine.findOne(SELECTOR_QUESTION, this.step);

		this.exitButton = SelectorEngine.find(SELECTOR_EXIT_BUTTON, this._wrapper);
		const exitConfirmModalHtml = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_MODAL, this._wrapper);
		this.exitConfirmModal = new Modal(exitConfirmModalHtml, { backdrop: 'static' });

		this.exitConfirmYes = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_YES, this._wrapper);
		this.exitConfirmNo = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_NO, this._wrapper);

		this._errorContainer = SelectorEngine.findOne(SELECTOR_ERRROR_CONTAINER, this._wrapper);
		this._errorText = SelectorEngine.findOne(ERROR_TEXT, this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne(DISMISS_ERROR_WRAPPER, this._errorContainer);

		// this.paymentLicenceWrapper = SelectorEngine.findOne('.js-lta-payment', this._wrapper);
		// this.addressSummary = SelectorEngine.findOne(SELECTOR_WRAPPER, this._element);
		// this.addressWrapper = SelectorEngine.findOne(VENUE_ADDRESS_SEARCH, this.addressSummary);
		// this.checkoutWrapper = SelectorEngine.findOne(CHECKOUT_WRAPPER, this._wrapper);
		// this.paidValueWrapper = SelectorEngine.findOne(PAID_VALUE_WRAPPER, this.checkoutWrapper);
		// this.freeValueWrapper = SelectorEngine.findOne(FREE_VALUE_WRAPPER, this.checkoutWrapper);
		// this.billingAddressWrapper = SelectorEngine.findOne(BILLING_ADDRESS_WRAPPER, this.checkoutWrapper);
		// this.cardPaymentWrapper = SelectorEngine.findOne('.licence-card-payment', this.paymentLicenceWrapper);
		// this.saveCardWrapper = SelectorEngine.findOne('.licence-save-card', this.paymentLicenceWrapper);
		// this.abtoWrapper = SelectorEngine.findOne('.abto-main-wrapper', this.paymentLicenceWrapper);
		// this.paymentBtnWrapper = SelectorEngine.findOne('.licence-payment-btn', this.paymentLicenceWrapper);
		// this.freeSubtitle = SelectorEngine.findOne('.checkout-free-subtitle', this._wrapper);
		// this.label_payment_Wrapper = SelectorEngine.findOne(
		// 	'.lta-accordion--sublabel-license-renewal-checkout',
		// 	this.checkoutWrapper
		// );

		// if (this.checkoutWrapper) {
		// 	if (this.isLicenceFree) {
		// 		this.paidValueWrapper.classList.add(HIDDEN_CLASS);
		// 		this.freeValueWrapper.classList.remove(HIDDEN_CLASS);
		// 		this.label_payment_Wrapper.innerHTML = 'FREE';
		// 		this.billingAddressWrapper.classList.add(HIDDEN_CLASS);
		// 		this.cardPaymentWrapper.classList.add(HIDDEN_CLASS);
		// 		this.saveCardWrapper.classList.add(HIDDEN_CLASS);
		// 		this.abtoWrapper.classList.add(HIDDEN_CLASS);
		// 		this.freeSubtitle.classList.remove(HIDDEN_CLASS);
		// 	} else {
		// 		this.paidValueWrapper.classList.remove(HIDDEN_CLASS);
		// 		this.freeValueWrapper.classList.add(HIDDEN_CLASS);
		// 		this.label_payment_Wrapper.innerHTML = '£25';
		// 		this.freeSubtitle.classList.add(HIDDEN_CLASS);
		// 	}
		// }

		this._closeErrorSnackBar.addEventListener(CLICK_EVENT, () => {
			this._errorContainer.classList.add(HIDDEN_CLASS);
		});

		const addressSearchElement = document.querySelector('.lta-address-search');
		this.addressSearchComp = AddressSearch.getInstance(addressSearchElement) || new AddressSearch(addressSearchElement);
		this.initEventHandlers();
	}

	initEventHandlers() {
		EventHandler.on(this.splashNext, Events.Click, () => {
			this.fetchSteps();
		});
		EventHandler.on(this.paymentBtnWrapper, 'click', () => {
			this.updateABTO();
		});

		this.exitButton.forEach(button => {
			EventHandler.on(button, Events.Click, () => {
				this.exitConfirmModal.show();
			});
		});
		EventHandler.on(this.exitConfirmYes, Events.Click, () => {
			this.handleModalExit();
		});
		EventHandler.on(this.exitConfirmNo, Events.Click, () => {
			this.exitConfirmModal.hide();
		});
	}

	handleSearchAgain() {
		const addressSummary = SelectorEngine.findOne(SELECTOR_WRAPPER, this._element);
		const addressSearch = SelectorEngine.findOne(ADDRESS_SEARCH_FIND, addressSummary);
		const addressCard = SelectorEngine.findOne(ADDRESS_SEARCH_CARD, addressSummary);
		addressSearch.classList.remove(ClassNames.Hidden);
		addressCard.classList.add(ClassNames.Hidden);

		const resultsView = SelectorEngine.findOne(RENEWAL_EDIT_ADDRESS, this._element);
		resultsView.classList.add(ClassNames.Hidden);
	}

	async fetchSteps() {
		try {
			// TODO CSA: this endpoint has not been confirmed yet
			const url = '/api/officials/licence-renewal'; // TODO CSA: this endpoint has not been confirmed ye
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
				this.fetchAddress();
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			console.log('error', error);

			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	async fetchAddress() {
		try {
			const url = '/api/officials/getofficiallicenserenewal';
			const data = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { response, error } = data;
			if (response) {
				// this.state.billingAddress = response?.billingAddress;
				// this.addressSearchComp.addAddress(response?.billingAddress, true, false);
				this.prefilledData(response);
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			console.log('error', error);

			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	async updateABTO() {
		this.abtoCheckbox = SelectorEngine.findOne('#abtoCheck', this._wrapper);
		const abtoCheck = this.abtoCheckbox.checked;
		const billingAddressCard = this.addressSearchComp.state.address;
		try {
			// TODO CSA: this endpoint has not been confirmed yet
			const url = '/api/license/renewal?contactId=' + this.contactId; // TODO CSA: this endpoint has not been confirmed ye
			const data = await Request.put(
				url,
				{
					billingAddress: {
						addressLine1: billingAddressCard?.addressLine1,
						addressLine2: billingAddressCard?.addressLine2,
						town: billingAddressCard?.town,
						postcode: billingAddressCard?.postcode
					},
					abtoStatus: abtoCheck
				},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { response, error } = data;
			if (error.errorCode === '00') {
				const rootUrl = window.location.origin;

				window.location.href = `${rootUrl}${'/pages/officials/licence-renewal-success-page/'}`;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			console.log('error', error);

			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	changeHandler(event) {
		for (const callback of this._changeCallbacks) {
			callback(event);
		}
	}

	renderSearchAgain() {
		return `<button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before lta-address-search--remove js-auto-edit lta-licence-renewal-edit">
		<svg class="lta-icon js-lta-text-input--btn-icon u-mr-0" width="1.5em" height="1.5em" fill="currentColor" alt="search" aria-hidden="true">
			<use xlink:href="/static/images/icons/lta-icons.svg#search"></use>
		</svg>
		Search again
	</button>`;
	}

	prefilledData(response) {
		const prevoiusSteps = this.stepsData;
		const updatedSteps = prevoiusSteps.map((item) => {
			switch (item.id) {
				case 1:
					return { ...item, value: response.phoneNumber };
				case 2:
					return { ...item, value: response.email };
				case 3:
					return { ...item, addressValue: response.address };
				default:
					break;
			}
		});

		this.stepsData = updatedSteps;
		this.initiateFormGenerator(updatedSteps);
		if (response.address !== undefined) {
			this.addAddress(response.address, true);
		}

		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
			this.submitSupportForm(this.answerList);
		});
	}

	addAddress(address, existing = false, isFocus = true) {
		const autoView = SelectorEngine.findOne(ADDRESS_SEARCH_FIND_SUGGEST, this.step);
		const addressSummary = SelectorEngine.findOne(ADDRESS_SEARCH_RESULT, this.step);
		const addressWrapper = SelectorEngine.findOne(LOCATION_CARD_SEARCH, addressSummary);
		const editButtonWrapper = SelectorEngine.findOne(CONTENT_ADDRESS_SEARCH, addressSummary);
		addressWrapper.textContent = '';

		const p = document.createElement('p');
		p.classList.add('u-body2');
		const streetEle = document.createTextNode(address.addressLine1);
		const cityEle = document.createTextNode(address.addressLine2);
		const stateEle = document.createTextNode(address.town);
		const postcodeEle = document.createTextNode(address.postcode);
		const countryEle = document.createTextNode('United Kingdom');

		p.append(streetEle);
		p.append(document.createElement('br'));
		p.append(cityEle);
		if (address.state !== '') {
			p.append(document.createElement('br'));
			p.append(stateEle);
		}
		p.append(document.createElement('br'));
		p.append(postcodeEle);
		if (!address.country || address.country !== '') {
			p.append(document.createElement('br'));
			p.append(countryEle);
		}

		addressWrapper.append(p);

		const hiddenInput = (name, value = '') => {
			const input = document.createElement('input');
			input.setAttribute('type', 'text');
			input.classList.add(ClassNames.Hidden);
			input.setAttribute('name', name);
			input.setAttribute('value', value);
			return input;
		};

		const streetInput = hiddenInput('street', address.addressLine1);
		const cityInput = hiddenInput('city', address.addressLine2);
		const stateInput = hiddenInput('state', address.town);
		const postCodeInput = hiddenInput('postCode', address.postcode);
		const countryInput = hiddenInput('country', 'United Kingdom');

		addressWrapper.append(streetInput);
		addressWrapper.append(cityInput);
		addressWrapper.append(stateInput);
		addressWrapper.append(postCodeInput);
		addressWrapper.append(countryInput);

		const formEvent = new CustomEvent('change', {
			bubbles: true,
			detail: { name: 'address', values: address, existing }
		});

		streetInput.dispatchEvent(formEvent);

		const isAddressMissing = !address.postcode && !address.addressLine1;

		addressSummary.classList.remove(ClassNames.Hidden);
		editButtonWrapper.classList.add(ClassNames.Hidden);
		autoView.classList.add(ClassNames.Hidden);
		const [firstCta, secondCta] = SelectorEngine.find('button', addressSummary);
		if (isAddressMissing && secondCta) {
			secondCta.click();
			const input = SelectorEngine.findOne(SELECTOR_HOUSE_INPUT, this._element);
			if (isFocus && input) input.focus();
		} else {
			if (isFocus) {
				firstCta.focus();
			}
		}
	}

	addBillingAddress(address, existing = false, isFocus = true) {
		const autoView = SelectorEngine.findOne(ADDRESS_SEARCH_FIND_SUGGEST, this.checkoutWrapper);
		const addressSummary = SelectorEngine.findOne(ADDRESS_SEARCH_RESULT, this.checkoutWrapper);
		const addressWrapper = SelectorEngine.findOne(LOCATION_CARD_SEARCH, addressSummary);
		const editButtonWrapper = SelectorEngine.findOne(CONTENT_ADDRESS_SEARCH, addressSummary);
		addressWrapper.textContent = '';

		const p = document.createElement('p');
		p.classList.add('u-body2');
		const streetEle = document.createTextNode(address.addressLine1);
		const cityEle = document.createTextNode(address.addressLine2);
		const stateEle = document.createTextNode(address.town);
		const postcodeEle = document.createTextNode(address.postcode);
		const countryEle = document.createTextNode('United Kingdom');

		p.append(streetEle);
		p.append(document.createElement('br'));
		p.append(cityEle);
		if (address.state !== '') {
			p.append(document.createElement('br'));
			p.append(stateEle);
		}
		p.append(document.createElement('br'));
		p.append(postcodeEle);
		if (!address.country || address.country !== '') {
			p.append(document.createElement('br'));
			p.append(countryEle);
		}

		addressWrapper.append(p);

		const hiddenInput = (name, value = '') => {
			const input = document.createElement('input');
			input.setAttribute('type', 'text');
			input.classList.add(ClassNames.Hidden);
			input.setAttribute('name', name);
			input.setAttribute('value', value);
			return input;
		};

		const streetInput = hiddenInput('street', address.addressLine1);
		const cityInput = hiddenInput('city', address.addressLine2);
		const stateInput = hiddenInput('state', address.town);
		const postCodeInput = hiddenInput('postCode', address.postcode);
		const countryInput = hiddenInput('country', 'United Kingdom');

		addressWrapper.append(streetInput);
		addressWrapper.append(cityInput);
		addressWrapper.append(stateInput);
		addressWrapper.append(postCodeInput);
		addressWrapper.append(countryInput);

		const formEvent = new CustomEvent('change', {
			bubbles: true,
			detail: { name: 'address', values: address, existing }
		});

		streetInput.dispatchEvent(formEvent);

		const isAddressMissing = !address.postcode && !address.addressLine1;

		addressSummary.classList.remove(ClassNames.Hidden);
		editButtonWrapper.classList.add(ClassNames.Hidden);
		autoView.classList.add(ClassNames.Hidden);
		const [firstCta, secondCta] = SelectorEngine.find('button', addressSummary);
		if (isAddressMissing && secondCta) {
			secondCta.click();
			const input = SelectorEngine.findOne(SELECTOR_HOUSE_INPUT, this._element);
			if (isFocus) input.focus();
		} else {
			if (isFocus) {
				firstCta.focus();
			}
		}
	}

	initiateFormGenerator(stepsData) {
		this.splash.classList.add(ClassNames.Hidden);
		this.step.classList.remove(ClassNames.Hidden);

		this.formGenerator = new FormGenerator(this.questions, {
			questions: stepsData,
			totalSteps: 1,
			hasSeparator: false,
			formType: FormTypes.StepForm,
			themeColor: 'color-lta-blue',
			radioAnswerField: 'id',
			isHideProgress: false,
			isBackButtonEnabled: true,
			mainPageElement: this.step,
			saveAddress: false,
			backButtonHandlerFirstStep: () => {
				this.splash.classList.remove(ClassNames.Hidden);
				this.step.classList.add(ClassNames.Hidden);
			}
		});
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					...this.answerList,
					...formatObject
				};
			}
		}
	}

	async submitSupportForm(payload) {
		startLoadingAnimation(true);
		// TODO CSA: this endpoint has not been confirmed yet
		const endpoint = '/api/officials/updateofficiallicenserenewal'; // TODO CSA: this endpoint has not been confirmed yet
		try {
			const url = endpoint;
			const data = await Request.put(url, payload, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { response } = data;
			const { Success, redirectURL } = response;
			if (Success === true) {
				this.goToUrl(redirectURL);
			} else {
				this._errorContainer.classList.remove('u-hidden');
				this._errorText.innerHTML = Manipulator.getDataAttribute(this.questions, 'api-failed-error');
			}
		} catch {
			this._errorContainer.classList.remove('u-hidden');
			this._errorText.innerHTML = Manipulator.getDataAttribute(this.questions, 'api-failed-error');
			this._errorContainer.scrollIntoView();
		} finally {
			stopLoadingAnimation();
		}
	}

	goToUrl(redirectURL) {
		if (!redirectURL) {
			return;
		}
		const rootUrl = window.location.origin;
		const url = redirectURL;
		window.location.href = `${rootUrl}${url}`;
	}

	handleModalExit() {
		// Go back to the page that launched the modal
		history.back();
	}
}

const globalOfficialsLicenceRenewal = new OfficialsLicenceRenewal();
export default globalOfficialsLicenceRenewal;
